import { render, staticRenderFns } from "./followUpPlanNew.vue?vue&type=template&id=a80e488a&"
import script from "./followUpPlanNew.vue?vue&type=script&lang=js&"
export * from "./followUpPlanNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports